import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-232b8fc9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "discounts" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headline d-flex-1f" }, "特惠拼团", -1))
const _hoisted_3 = { class: "more" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "tag" }
const _hoisted_6 = { class: "nowPrice" }
const _hoisted_7 = { class: "oldPrice" }
const _hoisted_8 = {
  key: 1,
  class: "empty"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headline d-flex-1f" }, "限时秒杀", -1))
const _hoisted_10 = { class: "more" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "tag seckill" }
const _hoisted_13 = { class: "nowPrice" }
const _hoisted_14 = { class: "oldPrice" }
const _hoisted_15 = {
  key: 1,
  class: "empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_RatioHeightContainer = _resolveComponent("RatioHeightContainer")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_row, { gutter: "20" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "12",
          class: "split-line-right"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "title d-flex",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toList(2)))
            }, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _createTextVNode(" 更多 "),
                _createVNode(_component_van_icon, { name: "arrow" })
              ])
            ]),
            (_ctx.LumpList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_van_row, { gutter: "18" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.LumpList, (item) => {
                          return (_openBlock(), _createBlock(_component_van_col, {
                            key: item,
                            span: "12",
                            class: "item-merchandise",
                            onClick: ($event: any) => (
                                    _ctx.goDetail(
                                        item.productId,
                                        2,
                                        item.preferentialActivitiesId,
                                        item.id
                                    )
                                )
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_RatioHeightContainer, {
                                ratio: 100,
                                class: "d-relative"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_van_image, {
                                    width: "100%",
                                    height: "100%",
                                    alt: "图片加载中...",
                                    fit: "cover",
                                    radius: "4px",
                                    src: _ctx.lumpImg(item.img)
                                  }, null, 8, ["src"]),
                                  _createElementVNode("span", _hoisted_5, _toDisplayString(item.groupBookingUserNum) + "人团 ", 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", _hoisted_6, " ￥" + _toDisplayString(_ctx.keepDecimal(item.presentPrice)), 1),
                              _createElementVNode("div", _hoisted_7, " ￥" + _toDisplayString(_ctx.keepDecimal(item.originalPrice)), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("加载中...")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("暂无数据")
                      ], 64))
                ]))
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "12" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "title d-flex",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toList(1)))
            }, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode(" 更多 "),
                _createVNode(_component_van_icon, { name: "arrow" })
              ])
            ]),
            (_ctx.seckillList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_van_row, { gutter: "18" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seckillList, (item) => {
                          return (_openBlock(), _createBlock(_component_van_col, {
                            key: item,
                            span: "12",
                            class: "item-merchandise",
                            onClick: ($event: any) => (
                                    _ctx.goDetail(
                                        item.productId,
                                        1,
                                        item.preferentialActivitiesId,
                                        item.id
                                    )
                                )
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_RatioHeightContainer, {
                                ratio: 100,
                                class: "d-relative"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_van_image, {
                                    width: "100%",
                                    height: "100%",
                                    alt: "图片加载中...",
                                    fit: "cover",
                                    radius: "4px",
                                    src: _ctx.lumpImg(item.img)
                                  }, null, 8, ["src"]),
                                  _createElementVNode("span", _hoisted_12, _toDisplayString(item.discount) + "折 ", 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", _hoisted_13, " ￥" + _toDisplayString(_ctx.keepDecimal(item.presentPrice)), 1),
                              _createElementVNode("div", _hoisted_14, " ￥" + _toDisplayString(_ctx.keepDecimal(item.originalPrice)), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("加载中...")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("暂无数据")
                      ], 64))
                ]))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}